/* eslint-disable react/no-unknown-property */
import { Button, Icon } from '@pypestream/design-system';
import { FC } from 'react';
import { useFileInput } from '../../hooks';

type UploadProps = {
  label: string;
  disabled?: boolean;
  accept?: string;
  'test-id'?: string;
  onUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Upload: FC<UploadProps> = ({
  label,
  disabled,
  accept = '.py',
  'test-id': testId,
  onUpload,
}) => {
  const { input, inputRef: fileInputRef } = useFileInput({
    'test-id': `${testId}-input`,
    disabled: disabled ?? false,
    accept,
    type: 'file',
    multiple: true,
    style: { display: 'none' },
    onChange: onUpload,
  });

  return (
    <>
      {input}
      <Button
        test-id={`${testId}-button`}
        size="large"
        variant="ghost"
        // Now reaches the visible button, not only the hidden input it guards.
        // Before, a caller passing `disabled` got a button that looked live and
        // silently did nothing when clicked — `action-section.tsx` passes
        // `!versionId`, so that was the state until a version had loaded.
        disabled={disabled}
        onClick={() => fileInputRef.current?.click()}
      >
        <Icon name="upload" slot="prefix" /> {label}
      </Button>
    </>
  );
};
